import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '../models';

@Injectable({ providedIn: 'root' })
export class TokenService {
    private userSubject: BehaviorSubject<User>;
    public user: Observable<User>;

    constructor(

    ) {

        // this.user = this.userSubject.asObservable();
    }

    public get userValue(): User {
        this.userSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('user')));
        return this.userSubject.value;
    }
}
